import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 10,
    padding: 10,
    background: '#FFFFFF',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 20,
  },
  subQuestionList: {
    margin: '10px 0',
    paddingLeft: 30,
    fontSize: 16,
    lineHeight: '24px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 0 9px',
      fontSize: 14,
    },
    '& li': {
      wordBreak: 'break-word',
      marginBottom: 0,
    },
    '& li:first-child': {
      fontWeight: 700,
    },
  },
  actionBtnGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignSelf: 'center',
    height: 'max-content',
  },
  subQuestion: {
    marginBottom: 20,
    '.rtl &': {
      wordBreak: 'break-word',
    },
  },
  button: {
    fontSize: 14,
    fontWeight: 400,
    textTransform: 'none',
    color: '#FF8C69',
    textDecoration: 'underline',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#FF8C69',
      textDecoration: 'underline',
    },
  },
}));
